import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Header from '../../../components/comm/Head';
import Navbar from '../../../components/comm/Navbar';
import style from './HealthResultsMain.module.css';

import AiPrediction from '../../../components/health-results/AiPrediction';
import HealthCheckup from '../../../components/health-results/HealthCheckup';
import HospitalResults from '../../../components/health-results/HospitalResults';
import GeneticResults from '../../../components/health-results/GeneticResults';

const TABS = [
    { key: 'ai',       label: 'AI예측' },
    { key: 'checkup',  label: '성모검진' },
    // { key: 'hospital', label: '성모병원' },
    { key: 'genetic',  label: '유전체' },
];

const HealthResultsMain = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const activeTab = searchParams.get('tab') || 'ai';

    const tabBarRef = useRef(null);
    const [indicatorStyle, setIndicatorStyle] = useState({});

    const updateIndicator = (key) => {
        const bar = tabBarRef.current;
        if (!bar) return;
        const btn = bar.querySelector(`[data-tab="${key}"]`);
        if (!btn) return;
        setIndicatorStyle({ left: btn.offsetLeft, width: btn.offsetWidth });
    };

    useEffect(() => { updateIndicator(activeTab); }, [activeTab]);
    useEffect(() => {
        const onResize = () => updateIndicator(activeTab);
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, [activeTab]);

    const handleTabChange = (key) => {
        setSearchParams({ tab: key });
    };

    const renderContent = () => {
        switch (activeTab) {
            case 'ai':       return <AiPrediction />;
            case 'checkup':  return <HealthCheckup />;
            // case 'hospital': return <HospitalResults />;
            case 'genetic':  return <GeneticResults />;
            default:         return null;
        }
    };

    return (
        <>
            <Header />
            <div id="sub-content" data-layout="white">
                <div className="inner-wrap" data-top-padding="0">
                    <div className={style.tabBar} ref={tabBarRef}>
                        {TABS.map(tab => (
                            <button
                                key={tab.key}
                                data-tab={tab.key}
                                className={`${style.tabItem} ${activeTab === tab.key ? style.active : ''}`}
                                onClick={() => handleTabChange(tab.key)}
                            >
                                {tab.label}
                            </button>
                        ))}
                        <span className={style.tabIndicator} style={indicatorStyle} />
                    </div>
                    {renderContent()}
                </div>
            </div>
            <Navbar />
        </>
    );
};

export default HealthResultsMain;